function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "var(--k-fg-419d3e)",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.33325 9.83333C9.33325 9.36662 9.33325 9.13327 9.42408 8.95501C9.50397 8.79821 9.63146 8.67072 9.78826 8.59083C9.96652 8.5 10.1999 8.5 10.6666 8.5H21.3333C21.8 8.5 22.0333 8.5 22.2116 8.59083C22.3684 8.67072 22.4959 8.79821 22.5758 8.95501C22.6666 9.13327 22.6666 9.36662 22.6666 9.83333V22.1667C22.6666 22.6334 22.6666 22.8667 22.5758 23.045C22.5358 23.1234 22.484 23.1945 22.4225 23.2559L20.9999 21.8333L19.7499 23.0833L18.4999 21.8333L17.2499 23.0833L15.9999 21.8333L14.7499 23.0833L13.4999 21.8333L12.2499 23.0833L10.9999 21.8333L9.57733 23.2559C9.51587 23.1945 9.46403 23.1234 9.42408 23.045C9.33325 22.8667 9.33325 22.6334 9.33325 22.1667V9.83333ZM11.0453 10.3942C10.9999 10.4833 10.9999 10.6 10.9999 10.8333V11.1667C10.9999 11.4 10.9999 11.5167 11.0453 11.6058C11.0853 11.6842 11.149 11.748 11.2274 11.7879C11.3166 11.8333 11.4332 11.8333 11.6666 11.8333H20.3333C20.5666 11.8333 20.6833 11.8333 20.7724 11.7879C20.8508 11.748 20.9146 11.6842 20.9545 11.6058C20.9999 11.5167 20.9999 11.4 20.9999 11.1667V10.8333C20.9999 10.6 20.9999 10.4833 20.9545 10.3942C20.9146 10.3158 20.8508 10.252 20.7724 10.2121C20.6833 10.1667 20.5666 10.1667 20.3333 10.1667H11.6666C11.4332 10.1667 11.3166 10.1667 11.2274 10.2121C11.149 10.252 11.0853 10.3158 11.0453 10.3942Z",
  fill: "var(--k-fg-419d3e)"
});

function SvgToast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToast);
export default __webpack_public_path__ + "static/media/toast.74831c4b.svg";
export { ForwardRef as ReactComponent };